export enum Modes {
    BROADCAST = 0,
    OBS = 1,
    RTMP = 2,
}